// extracted by mini-css-extract-plugin
export default {"component":"bvlRv0","branded":"cvlRv0","takeover":"dvlRv0","icon":"evlRv0","text":"fvlRv0"};